import { Component, ViewEncapsulation, OnInit, Inject } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";

export interface DialogData {
  contractId: string;
  moduleId: string;
  moduleName: string;
}

@Component({
  selector: 'activate.module.dialog',
  templateUrl: './activate.module.dialog.component.html',
  styleUrls: ['./activate.module.dialog.component.scss']
})

export class ActivateModuleDialogComponent implements OnInit {
  contractId: string;
  moduleId: string;
  moduleName: string;
  readAboutActivatingText: string;

  constructor(
    public dialogRef: MatDialogRef<ActivateModuleDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogData,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private translateService: TranslateService) {

    this.matIconRegistry.addSvgIcon('close', this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/icons/baseline-close-24px.svg'));
    if (window.addEventListener) {
      window.addEventListener('message', this.receiveMessage.bind(this), false);
    } else {
      (<any>window).attachEvent('onmessage', this.receiveMessage.bind(this));
    }
    this.contractId = data.contractId;
    this.moduleId = data.moduleId;
    this.moduleName = data.moduleName;
  }

  ngOnInit() {
    this.getReadAboutActivatingText().subscribe(text => {
      this.readAboutActivatingText = text.replace(`{{module_name}}`, this.moduleName);
    }, error => console.error(error));
  }

  receiveMessage: any = (event: any) => {
    if (event.data && event.data.closeDialog) {
      this.dialogRef.close();
    }
  };

  onCloseClick(): void {
    this.dialogRef.close(false);
  }

  onConfirmationClick() {
    this.dialogRef.close(true);
  }

  getReadAboutActivatingText() : Observable<string> {
    return this.translateService.get('Activate_Module_Confirmation_Text');
  }
}
